import { POST } from "../../index";

export const queryRepairList = (param) => POST("/v1/RequestRepairController/queryList", param);
export const insertRepair = (param) => POST("/v1/RequestRepairController/insert", param);
export const urgeRepair = (param) => POST("/v1/RequestRepairController/urgeRepairRepair", param);
export const finishRepair = (param) => POST("/v1/RequestRepairController/finishRepairRepair", param);

export const queryMaintainList = (param) => POST("/v1/RepairController/queryList", param);
export const insertMaintain = (param) => POST("/v1/RepairController/insert", param);
export const deleteMaintain = (param) => POST("/v1/RepairController/delete", param);


